// @flow
import * as React from 'react';
import styled from 'styled-components';
import Box from 'components/Box';
import Button from 'components/Button';
import Icon from 'components/Icon';
import { colors, transition, fontWeights } from 'theme';

const CloseButton = styled(Button)`
  color: ${colors.battleshipGrey};
  transition: all ${transition};
  &:hover {
    color: ${colors.waterBlue};
  }
`;

type Status = 'NEW';

const getStatus: Status => {
  theme: { bg: string, color: string },
  label: string
} = status => {
  switch (status) {
    case 'NEW':
    default:
      return {
        theme: {
          color: 'white',
          bg: colors.waterBlue
        },
        label: getText('New')
      };
  }
};

const UserNotification = ({
  status,
  children,
  dismiss,
  ...props
}: {
  status: Status,
  children: React.Node,
  dismiss?: Function
}) => {
  const { theme, label } = getStatus(status);
  return (
    <Box position="relative" {...props}>
      <Box
        data-qa-id="listing-status"
        display="inline-block"
        py="3px"
        px="6px"
        mb={12}
        borderRadius="4px"
        letterSpacing="1px"
        textTransform="uppercase"
        lineHeight={1}
        fontWeight={fontWeights.semiBold}
        fontSize={11}
        {...theme}
      >
        {label}
      </Box>

      <Box lineHeight={1.375}>{children}</Box>

      {dismiss && (
        <Box position="absolute" top={0} right={0}>
          <CloseButton onClick={dismiss}>
            <Icon name="close" width={12} height={12} fill="currentColor" />
          </CloseButton>
        </Box>
      )}
    </Box>
  );
};

export default UserNotification;
